import { Component, Input } from '@angular/core';
import { ChallengeShadowBoxingService, ChallengeStatusType, ChallengeStatusValues, DIFFICULTY, DifficultKeys, GEMS, TChallenge } from 'src/app/gamification/command-center/services/challenge-shadow-boxing.service';

const dateValues = {
  [ChallengeStatusValues.PENDING]: {
    dateTitle: 'Starts',
    dateValue: 'StartDate_NoYear',
  },
  [ChallengeStatusValues.UPCOMING]: {
    dateTitle: 'Starts',
    dateValue: 'StartDate_NoYear',
  },
  [ChallengeStatusValues.ACTIVE]: {
    dateTitle: 'EndDate',
    dateValue: 'EndDate_NoYear',
  },
  [ChallengeStatusValues.ENDED]: {
    dateTitle: 'Ended',
    dateValue: 'EndDate_NoYear',
  },
}


@Component({
  selector: 'cv-challenge-card-view',
  templateUrl: './challenge-card-view.component.html',
  styleUrl: './challenge-card-view.component.scss'
})
export class ChallengeCardViewComponent {

  @Input()
  challenge: TChallenge = {};

  @Input()
  challengeStatus: ChallengeStatusType = ChallengeStatusValues.UNKNOW;

  constructor(private shadowBoxingService: ChallengeShadowBoxingService) {
  }
  
  get isPendingChallenge() {
    const pendingStatus: number[] = [ChallengeStatusValues.PENDING, ChallengeStatusValues.UPCOMING];
    return pendingStatus.includes(this.challengeStatus);
  }

  get myScore() {
    if (this.isPendingChallenge) return '---';
    if (this.challenge?.Rankings?.length == 1 && this.challenge.Rankings[0].ViewScore) return this.challenge.Rankings[0].ViewScore;
    return '---';
  }

  get scoreGoal() {
    if (this.isPendingChallenge) return '---';
    return this.challenge.shadowBoxing?.DailyGoalMetricString;
  }

  get reward() {
    const difficulty: DifficultKeys = DIFFICULTY[this.challenge.shadowBoxing?.Difficulty || 1];
    return GEMS[difficulty];
  }

  get hasPunch() {
    return this.challengeStatus === ChallengeStatusValues.ACTIVE && this.challenge?.shadowBoxing?.hasPunch && !this.challenge.ChallengeWasRemoved && !this.shadowBoxingService.isChallengeWon(this.challenge.shadowBoxing);
  }

  get reachDailyGoal() {
    if (this.challenge?.Rankings?.length == 1 && this.challenge.Rankings[0].ViewScore) {
      const score = this.challenge.Rankings[0].MetricValue || 0;
      const metricDirection = this.challenge.MetricDefaultDirection;
      if (metricDirection == 1) {
        return score >= this.challenge.shadowBoxing.DailyGoalMetricValue;
      }
      else if (metricDirection == 0) {
        return score <= this.challenge.shadowBoxing.DailyGoalMetricValue;
      }
    }
    return false;
  }

  get dateTitle() {
    return dateValues[this.challengeStatus]?.dateTitle;
  }

  get dateValue() {
    return this.challenge[dateValues[this.challengeStatus]?.dateValue];
  }

}
